import * as Actions from 'actionTypes';

const popular = (state: Object = { isLoading: true }, action: Object) => {
  if (action.type === Actions.ADD_POPULAR_RESULTS_FAILED) {
    const newState = Object.assign({}, state);
    newState.isLoading = false;
    return newState;
  } else if (action.type === Actions.FETCH_POPULAR_RESULTS) {
    const newState = Object.assign({}, state);
    newState.isLoading = true;
    return newState;
  } else if (action.type === Actions.ADD_POPULAR_RESULTS) {
    return {
      ...state,
      isLoading: false,
      ...action.results
    };
  }

  return state;
};

export default popular;



// WEBPACK FOOTER //
// ./src/reducers/popular.reducer/index.js